import KirunaWrapup from '@containers/IQOSUniverse/articles/KirunaWrapup/KirunaWrapup';

export default KirunaWrapup;